import { makeStyles } from '@mui/styles';
import { List } from 'immutable';
import { useRef } from 'react';

import { Paper, Grid, Typography } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Placeholder } from 'components';
import { Search } from '@mui/icons-material';

const EventsScrollableList = ({
	onDragEnd,
	id,
	ListItem,
	ListContainer = List,
	list
}) => {
	const classes = useStyles();
	const sortListContainer = useRef(null);
	const _onDragEnd = (result) => {
		if (!result.destination) {
			return result;
		}
		const items = reorder(list, result.source.index, result.destination.index);
		onDragEnd(items);
	};

	return (
		<DragDropContext onDragEnd={_onDragEnd}>
			<Droppable droppableId={id}>
				{(provided) => (
					<Paper
						ref={sortListContainer}
						style={{
							minHeight: sortListContainer?.current?.clientHeight
						}}
					>
						<Grid container spacing={1} className={classes.root}>
							<Grid item md={1} xs={12}>
								{''}
							</Grid>
							<Grid item md={3} xs={12}>
								<Typography
									variant="body1"
									color={'primary'}
									className={classes.text}
								>
									{'Event Name'}
								</Typography>
							</Grid>
							<Grid item md={2} xs={12}>
								<Typography
									variant="body1"
									color={'primary'}
									className={classes.text}
								>
									{'Start Date'}
								</Typography>
							</Grid>
							<Grid item md={2} xs={12}>
								<Typography
									variant="body1"
									color={'primary'}
									className={classes.text}
								>
									{'End Date'}
								</Typography>
							</Grid>
							<Grid item md={2} xs={12}>
								<Typography
									variant="body1"
									color={'primary'}
									className={classes.text}
								>
									{'Published'}
								</Typography>
							</Grid>
							<Grid item md={1} xs={12}>
								{' '}
							</Grid>
						</Grid>
						<ListContainer {...provided.droppableProps} ref={provided.innerRef}>
							{list.map((item, index) => (
								<Draggable
									key={item.id}
									draggableId={item.id.toString()}
									index={index}
								>
									{(provided, snapshot) => (
										<div
											ref={provided.innerRef}
											{...provided.draggableProps}
											{...provided.dragHandleProps}
											style={getItemStyle(
												snapshot.isDragging,
												provided.draggableProps.style
											)}
										>
											<ListItem item={item} index={index} />
										</div>
									)}
								</Draggable>
							))}

							{list.length < 1 && (
								<Placeholder
									icon={<Search />}
									title="No Events"
									subtitle="No events found"
								/>
							)}
							{provided.placeholder}
						</ListContainer>
					</Paper>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default EventsScrollableList;

const getItemStyle = (_, draggableStyle) => ({
	userSelect: 'none',
	...draggableStyle
});

const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result.map((item, index) => ({
		...item,
		position: index + 1
	}));
};

const useStyles = makeStyles((theme) => ({
	root: {
		padding: 20
	},
	item: { verticalAlign: 'center' },
	text: { paddingTop: 20 },
	icon: { color: '#757575', marginLeft: 20, marginTop: 20 },
	button: { paddingTop: 20 }
}));
